import { useGamesStore } from '../../store';

export const useGamesData = () => {
  return useGamesStore((store) => store.games.data);
};
